export default __webpack_public_path__ + "static/media/flattop-dude-surprised.4155e95c.png";